const sideviewWrapperSelector = '.js-sideview'
const sideviewSelector = '.js-sideview_view'
const openSideviewButtonSelector = '.js-open_sideview'
const closeSideviewButtonSelector = '.js-close_sideview'

function open(openButton, sideviewElement) {
  if (sideviewElement.hasAttribute('hidden')) {
    openButton.setAttribute('aria-expanded', 'true')

    requestAnimationFrame(() => {
      sideviewElement.classList.add('show')
      sideviewElement.removeAttribute('hidden')
      sideviewElement.querySelector(closeSideviewButtonSelector).focus()
    })
  }
}

function close(sideviewElement) {
  function restoreFocus() {
    const openSideviewButtons = Array.from(document.querySelectorAll(openSideviewButtonSelector))
    const button = openSideviewButtons.find(button => button.getAttribute('aria-controls') === sideviewElement.id)

    if (button) {
      button.setAttribute('aria-expanded', 'false')
      button.focus()
    }
  }

  if (!sideviewElement.hasAttribute('hidden') && !sideviewElement.classList.contains('hide')) {
    sideviewElement.addEventListener(
      'animationend',
      () => {
        sideviewElement.setAttribute('hidden', true)
        sideviewElement.classList.remove('hide')
      },
      { once: true }
    )
    requestAnimationFrame(() => {
      sideviewElement.classList.remove('show')
      sideviewElement.classList.add('hide')
    })

    restoreFocus()
  }
}

up.compiler(sideviewWrapperSelector, function (sideview, dataset) {
  const sideviewElement = sideview.querySelector(sideviewSelector)

  if ('expandOnUnpolyRender' in dataset) {
    const button = sideview.querySelector(openSideviewButtonSelector)
    open(button, sideviewElement)
  }

  sideviewElement.addEventListener('keydown', function (event) {
    if (event.code === 'Escape') {
      close(sideviewElement)
      return false
    }
  })

  const closeIfClickOutside = function (event) {
    !sideviewElement.contains(event.target) && close(sideviewElement)
  }
  return up.on('click up:link:follow', closeIfClickOutside)
})

up.on('click', openSideviewButtonSelector, function (event, button) {
  const controlledSideviewId = button.getAttribute('aria-controls')
  const sideviewElement = document.getElementById(controlledSideviewId)
  open(button, sideviewElement)
  event.preventDefault()
  return false
})

up.on('click', closeSideviewButtonSelector, function (event, button) {
  const sideviewElement = button.closest(sideviewSelector)
  close(sideviewElement)
  event.preventDefault()
  return false
})
